(function () {
  var marker = '20260720-final';

  function set(el, styles) {
    if (!el) return;
    Object.keys(styles).forEach(function (key) {
      if (el.style.getPropertyValue(key) === styles[key] && el.style.getPropertyPriority(key) === 'important') return;
      el.style.setProperty(key, styles[key], 'important');
    });
  }

  function ensureCloseIcon(button) {
    if (!button) return;
    var svg = button.querySelector('svg');
    if (!svg) {
      button.innerHTML = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
    }
  }

  function repairDialog(dialog) {
    if (!dialog) return;
    dialog.setAttribute('data-zoalin-localization-final', marker);
    set(dialog, {
      position: 'fixed',
      inset: '0',
      width: '100vw',
      'max-width': 'none',
      height: '100dvh',
      margin: '0',
      padding: '0',
      border: '0',
      background: '#fff',
      color: '#111',
      'font-size': '16px',
      'line-height': '1.35',
      overflow: 'hidden',
      'z-index': '2147483647'
    });

    set(dialog.querySelector('.zoalin-localization__modal'), {
      display: 'flex',
      'flex-direction': 'column',
      width: '100%',
      height: '100dvh',
      margin: '0',
      padding: '0',
      background: '#fff',
      color: '#111',
      overflow: 'hidden'
    });

    set(dialog.querySelector('.zoalin-localization__header'), {
      display: 'flex',
      'align-items': 'center',
      'justify-content': 'space-between',
      gap: '14px',
      'min-height': '78px',
      padding: '18px 16px 14px',
      'border-bottom': '1px solid #e8e2d9',
      background: '#fff',
      color: '#111'
    });

    set(dialog.querySelector('.zoalin-localization__heading-copy'), {
      display: 'block',
      flex: '1 1 auto',
      'min-width': '0',
      margin: '0',
      padding: '0'
    });

    dialog.querySelectorAll('.zoalin-localization__kicker, .zoalin-localization__subtitle').forEach(function (el) {
      set(el, {
        display: 'none',
        visibility: 'hidden',
        width: '0',
        height: '0',
        margin: '0',
        padding: '0',
        overflow: 'hidden'
      });
    });

    var title = dialog.querySelector('.zoalin-localization__title');
    if (title && !title.textContent.trim()) title.textContent = 'Select your country';
    set(title, {
      display: 'block',
      visibility: 'visible',
      opacity: '1',
      width: 'auto',
      'max-width': 'calc(100vw - 94px)',
      height: 'auto',
      margin: '0',
      padding: '0',
      color: '#111',
      'font-size': '22px',
      'font-weight': '720',
      'line-height': '1.12',
      'text-align': 'left',
      'text-transform': 'none',
      'white-space': 'normal'
    });

    var close = dialog.querySelector('.zoalin-localization__close');
    ensureCloseIcon(close);
    set(close, {
      display: 'grid',
      'place-items': 'center',
      width: '42px',
      'min-width': '42px',
      height: '42px',
      'min-height': '42px',
      margin: '0',
      padding: '0',
      border: '1px solid #ded8cf',
      background: '#fff',
      color: '#111',
      opacity: '1',
      visibility: 'visible'
    });
    if (close) {
      close.querySelectorAll('svg, path').forEach(function (el) {
        set(el, {
          display: 'block',
          width: '18px',
          height: '18px',
          color: '#111',
          stroke: '#111',
          fill: 'none',
          opacity: '1',
          visibility: 'visible'
        });
      });
    }

    set(dialog.querySelector('.zoalin-localization__search'), {
      flex: '0 0 auto',
      margin: '14px 16px 8px',
      color: '#111'
    });
    dialog.querySelectorAll('.zoalin-localization__search input').forEach(function (input) {
      set(input, {
        width: '100%',
        height: '52px',
        'min-height': '52px',
        'border-color': '#34312d',
        background: '#fff',
        color: '#111',
        'font-size': '16px',
        'line-height': '1.25',
        '-webkit-text-size-adjust': '100%'
      });
    });

    set(dialog.querySelector('.zoalin-localization__list'), {
      flex: '1 1 auto',
      display: 'block',
      width: '100%',
      'max-height': 'none',
      margin: '0',
      padding: '8px 16px max(22px, env(safe-area-inset-bottom))',
      background: '#fff',
      color: '#111',
      'font-size': '16px',
      'line-height': '1.35',
      'overflow-x': 'hidden',
      'overflow-y': 'auto',
      '-webkit-overflow-scrolling': 'touch'
    });

    dialog.querySelectorAll('.zoalin-localization__country, [data-country-code]').forEach(function (row) {
      var hidden = row.hasAttribute('hidden') || row.hidden;
      if (!hidden) {
        set(row, {
          display: 'grid',
          'grid-template-columns': '24px minmax(0, 1fr) 20px',
          'align-items': 'center',
          gap: '12px',
          'min-height': '52px',
          margin: '0',
          padding: '0 8px',
          'border-bottom': '1px solid #ece7df',
          background: row.classList.contains('is-current') || row.getAttribute('aria-selected') === 'true' ? '#f7f4ef' : 'transparent',
          color: '#111',
          'font-size': '16px',
          'line-height': '1.25',
          'text-align': 'left',
          opacity: '1',
          visibility: 'visible'
        });
      }

      row.querySelectorAll('.zoalin-localization__country-name, .zoalin-localization__currency').forEach(function (label) {
        set(label, {
          display: 'block',
          visibility: 'visible',
          opacity: '1',
          width: 'auto',
          height: 'auto',
          'min-width': '0',
          'max-width': '100%',
          color: label.classList.contains('zoalin-localization__currency') ? '#6d6760' : '#111',
          'font-size': label.classList.contains('zoalin-localization__currency') ? '13px' : '16px',
          'font-weight': label.classList.contains('zoalin-localization__currency') ? '450' : '500',
          'line-height': '1.25',
          overflow: 'hidden',
          'text-overflow': 'ellipsis',
          'white-space': 'nowrap'
        });
      });

      row.querySelectorAll('span:not(.zoalin-localization__country-flag):not(.zoalin-localization__check)').forEach(function (label) {
        set(label, {
          display: 'block',
          visibility: 'visible',
          opacity: '1',
          color: label.classList.contains('zoalin-localization__currency') ? '#6d6760' : '#111',
          'font-size': label.classList.contains('zoalin-localization__currency') ? '13px' : '16px',
          'font-weight': label.classList.contains('zoalin-localization__currency') ? '450' : '500',
          'line-height': '1.25',
          'text-shadow': 'none'
        });
      });

      set(row.querySelector('.zoalin-localization__country-flag'), {
        display: 'block',
        visibility: 'visible',
        opacity: '1',
        width: '24px',
        'min-width': '24px',
        height: '16px',
        'min-height': '16px'
      });

      row.querySelectorAll('.zoalin-localization__check, .zoalin-localization__check svg, .zoalin-localization__check path').forEach(function (el) {
        set(el, {
          color: '#111',
          stroke: '#111',
          opacity: '1'
        });
      });
    });
  }

  function repairAll() {
    document.querySelectorAll('.zoalin-localization__dialog').forEach(repairDialog);
  }

  function schedule() {
    repairAll();
    [30, 120, 300, 700, 1400, 2600].forEach(function (delay) {
      setTimeout(repairAll, delay);
    });
  }

  document.addEventListener('DOMContentLoaded', schedule);
  document.addEventListener('click', function (event) {
    if (event.target && event.target.closest && event.target.closest('[data-localization-open], .zoalin-localization__trigger')) {
      setTimeout(schedule, 0);
      setTimeout(schedule, 180);
    }
  }, true);
  document.addEventListener('input', function (event) {
    if (event.target && event.target.closest && event.target.closest('.zoalin-localization__dialog')) {
      setTimeout(repairAll, 0);
    }
  }, true);

  schedule();
})();
